import { NavLink } from 'react-router-dom'
import { cn } from '@/shared/utils/cn'
import type { NavLeaf } from './navigation'

interface SidebarNavLeafProps {
  item: NavLeaf
  /** Marca el item como hijo de un grupo (cambia la indentación). */
  nested?: boolean
}

export function SidebarNavLeaf({ item, nested = false }: SidebarNavLeafProps) {
  return (
    <NavLink
      to={item.to}
      end={item.end}
      className={({ isActive }) =>
        cn(
          'group relative mx-3 mb-0.5 flex items-center gap-3 rounded-lg py-2.5 text-[13.5px] font-medium transition-colors',
          nested ? 'pl-11 pr-3' : 'px-3',
          isActive
            ? 'bg-sidebar-active text-white before:absolute before:-left-3 before:bottom-2.5 before:top-2.5 before:w-[3px] before:rounded-sm before:bg-brand'
            : 'text-[#b7bdc8] hover:bg-sidebar-hover hover:text-white',
        )
      }
    >
      {!nested && <item.icon className="h-[18px] w-[18px]" />}
      <span className="flex-1">{item.label}</span>
      {item.comingSoon && (
        <span className="rounded bg-amber-300 px-1.5 py-0.5 text-[9px] font-bold text-amber-900">
          PRONTO
        </span>
      )}
    </NavLink>
  )
}
